import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { Helmet } from "react-helmet-async";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CategoryIntialValues, editCategoryValidationSchema } from "../../constant";
import { useMutateEditCategory, useMutateCreateImage } from "../../hooks/useApiHook";
import { GetGuideOptions, GetSingleCategory } from "../../../../Api/category";
import CustomSelect from "../../../../Utils/CustomSelect";
import { MdModeEditOutline } from "react-icons/md";
import MultiLevelSelect from "../../../../Components/MultiLevelSelectBox";
import { GetCategoryOptions } from "../../../../Api/productVariations";
import SaveButton from "../../../../Components/SaveButton";
import BackButton from "../../../../Components/BackButton";
import DiscoverImageSelect from "../../../Discover/components/ImageUpload";
import { useQuery } from "@tanstack/react-query";
import InputWithLabel from "../../../../Components/InputWithLabel";
import { SuccessToast } from "../../../../Utils/SweetAlert";

const EditCategory = () => {

  const navigate = useNavigate();
  const formRef = useRef();
  const stateData = useLocation();

  const { id } = stateData?.state || "";
  const [selectedValue, setSelectedValue] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSelectChange = (option) => {
    setSelectedValue(option);
  };

  const editCategoryApi = useMutateEditCategory();
  const addImageApi = useMutateCreateImage();

  const { data, refetch } = useQuery({
    queryKey: ["get-single-category"],
    queryFn: () => GetSingleCategory({ id: id }),
    throwOnError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server Error.");
    },
  });

  const { isFetching: isGuideOptionsLoading, data: GuideOptions, } = useQuery({
    queryKey: ["get-guide-option"],
    queryFn: () => GetGuideOptions({ search: "" }),

    select: (data) => [
      ...data.data.map((item) => ({
        ...item,
        value: item._id,
        label: item.name,
      })),
    ],
    throwOnError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server Error.");
    },
  });

  useEffect(() => {
    if (data) {
      if (formRef?.current?.values) {
        formRef?.current?.setValues({
          name: data?.data?.name,
          guide: data?.data?.guideProductId || null,
          parentCategoryId: data?.data?.parentCategoryId || null,
          image: data?.data?.imageUrl || "",
        });
      }
    }
  }, [data]);

  useEffect(() => {
    refetch();
  }, []);


  function getLastNameFromUrl(fullUrl) {
    try {
      const url = new URL(fullUrl);
      return url.pathname.replace(/^\/+/, '').replace("uploads/", "");
    } catch (error) {
      return fullUrl;
    }
  }

  const handleSubmitEditCategory = (values) => {
    const reqData = {
      id: id,
      name: values?.name,
      guideProductId: values?.guide || null,
      parentCategoryId: values?.parentCategoryId || null,
      image: values?.image ? getLastNameFromUrl(values.image) : "",
    };
    setIsLoading(true);
    editCategoryApi.mutate(reqData, {
      onSuccess: (response) => {
        SuccessToast(response?.message || " Product Updated.");
        navigate("/admin/category-listing");
        setIsLoading(false);
      },
      onError: (error) => {
        ErrorToast(error?.response?.data?.message || "Server Error.");
        setIsLoading(false);
      },
    });
  };


  return (
    <>
      <Helmet>
        <title>OVE | Admin Edit Category</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-border overflow-visible">
                <div className="card-body">
                  <div className="page-header d-block">
                    <div className="row">
                      <div className="col">
                        <h3 className="page-title">Edit Category</h3>
                      </div>
                      <div className='col-auto d-flex align-items-center justify-content-center'>
                        <BackButton to='/admin/category-listing' />
                      </div>
                    </div>
                  </div>
                  <section className="section-border">
                    <Formik
                      initialValues={CategoryIntialValues}
                      validationSchema={editCategoryValidationSchema}
                      validateOnChange
                      onSubmit={handleSubmitEditCategory}
                      innerRef={formRef}
                    >
                      {(formik) => {
                        const {
                          errors,
                          touched,
                          isSubmitting,
                          setFieldValue,
                          values,
                        } = formik;
                        return (
                          <Form>
                            <div className="row dis-spacing">
                              <div className="col-4">
                                <Field
                                  Label="Image"
                                  name="image"
                                  component={DiscoverImageSelect}
                                  require={true}
                                />
                              </div>
                              <div className="col-8">
                                <div className="row">
                                  <div className="col-md-12">
                                    <Field
                                      Label="Name"
                                      type="text"
                                      name="name"
                                      placeholder="Enter Category Name"
                                      component={InputWithLabel}
                                    />
                                  </div>

                                  <div className="col-md-12 mt-3">
                                    <label className="" htmlFor="guide">
                                      Guide
                                    </label>
                                    <CustomSelect
                                      name="guide"
                                      options={GuideOptions}
                                      placeholder="Select Guide"
                                      isLoading={isGuideOptionsLoading}
                                      onChange={(option) =>
                                        // setFieldValue("guide", option.value)
                                        setFieldValue("guide", option ? option.value : null)
                                      }
                                      value={GuideOptions?.find(
                                        (item) => item.value === values.guide
                                      )}
                                      isClearable
                                    />
                                    <ErrorMessage
                                      name="guide"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-12 ps-0 mt-3">
                                  <label htmlFor="parentCategoryId">Category</label>
                                  <MultiLevelSelect
                                    name="parentCategoryId"
                                    defaultValues={values?.parentCategoryId}
                                  />
                                </div>
                              </div>
                            </div>

                            <SaveButton loading={isLoading} />
                          </Form>
                        );
                      }}
                    </Formik>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditCategory;
